import React, { useEffect, useState } from "react";
import { supabase } from "../client/client";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useLogin } from "../context/LoginContext";
import Layout from "./Layout";
import Loading from "./Loading";

const SearchResultPage = () => {
    const { term } = useParams();
    const [loading, setLoading]           = useState(true);
    const { getSessionAuth }              = useLogin();
    const [userData, setUserData]         = useState(null);
    const [searchResults, setSearchResults] = useState([]);
    const navigate                        = useNavigate();
    const [processArea, setProcessArea]   = useState([]);
    const [noResults, setNoResults]       = useState(false);

    useEffect(() => {
        const sessionAuth = async () => {
            const session = await getSessionAuth();
            if (session) {
                await getUser(session.id);
                setLoading(false);
            } else {
                navigate("/", { replace: true });
            }
        };
        sessionAuth();
    }, []);

    const getUser = async (id) => {
        const { error, data } = await supabase
            .from("users").select().eq("id", id).single();
        if (error) throw error.message;
        setUserData(data);
    };

    async function fetchProcess() {
        try {
            if (!userData) return;
            const { data, error } = await supabase
                .from("area_users")
                .select("id_area, areas(name)")
                .eq("id_user", userData.id);

            if (error) {
                console.error("Error fetching areas:", error.message);
                return;
            }
            if (data.length === 0) return;
            setProcessArea(data.map((item) => item.areas.name));
        } catch (error) {
            console.error("Unexpected error:", error);
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            await fetchProcess();
            fetchSearchResults();
        };
        fetchData();
    }, [term, userData, processArea]);

    const fetchSearchResults = async () => {
        try {
            const safeTerm = term.replace(/'/g, "''");
            let query = supabase
                .from("equipos")
                .select("*")
                .or(
                    `title.ilike.%${safeTerm}%,` +
                    `brand.ilike.%${safeTerm}%,` +
                    `model.ilike.%${safeTerm}%,` +
                    `attendant.ilike.%${safeTerm}%,` +
                    `tags.ilike.%${safeTerm}%,` +
                    `serial.ilike.%${safeTerm}%`
                );

            if (userData?.role !== "admin") {
                query = query.in("area", processArea);
            }

            const { data, error } = await query;

            if (error) {
                console.error("Error fetching results:", error.message);
                return;
            }

            setSearchResults(data);
            setNoResults(data.length === 0);
        } catch (error) {
            console.error("Unexpected error:", error);
        }
    };

    return (
        <Layout>
            {loading && <Loading />}
            {noResults ? (
                <div className="text-center py-16">
                    <p className="text-gray-400 text-5xl mb-4">🔍</p>
                    <h2 className="text-red-500 font-semibold text-2xl">
                        No se encontraron resultados para "{term}"
                    </h2>
                    <p className="text-gray-500 mt-2 text-sm">Intenta con otro término de búsqueda.</p>
                </div>
            ) : (
                <>
                    <h1 className="text-[#356674] font-semibold text-2xl pb-6">
                        Resultados para: <span className="text-[#4691A6]">"{term}"</span>
                    </h1>
                    <div className="grid md:grid-cols-5 grid-cols-3 gap-6">
                        {searchResults.map((result) => (
                            <Link
                                to={`/informacion/${result.id}`}
                                key={result.id}
                                className="flex flex-col gap-2 border border-gray-200 rounded-xl overflow-hidden hover:shadow-md hover:border-[#4691A6] transition-all duration-200"
                            >
                                <img
                                    src={result.image1 || "/images/producto.jpeg"}
                                    alt={result.title}
                                    className="w-full aspect-square object-cover"
                                />
                                <div className="p-3">
                                    <h3 className="text-[#356674] font-bold text-sm leading-tight">
                                        {result.title}
                                    </h3>
                                    <h4 className="text-gray-500 text-xs mt-1">{result.area}</h4>
                                </div>
                            </Link>
                        ))}
                    </div>
                </>
            )}
        </Layout>
    );
};

export default SearchResultPage;
